import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M17.293 13.293L15 11V6.252C15 2.967 12.468.102 9.185.003A6 6 0 0 0 3 6v5L.707 13.293C.077 13.923.523 15 1.414 15h5.148a2.351 2.351 0 0 0-.062.5 2.5 2.5 0 1 0 5 0c0-.173-.027-.338-.062-.5h5.148c.891 0 1.337-1.077.707-1.707zM10.3 15.5a1.301 1.301 0 0 1-2.6 0c0-.181.049-.346.119-.5h2.363c.069.154.118.319.118.5zm-8.403-1.7l1.951-1.952.352-.351V6c0-2.647 2.153-4.8 4.8-4.8l.148.002c2.565.077 4.652 2.342 4.652 5.05v5.245l.352.351 1.952 1.952H1.897z" />
  </svg>
);

export default SvgComponent;
